class QuestionnaireSection extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.js-click').forEach((target) => {
      target.addEventListener('click', (e) => {
        const currentStep = e.target.closest('.qs-step');
        const nextStep = currentStep.nextElementSibling;
        if (nextStep && nextStep.classList.contains('qs-step')) {
          nextStep.classList.add('qs-step--open');
          nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
}

customElements.define('questionnaire-section', QuestionnaireSection);
